import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppDispatch } from 'store';
import { signOut } from 'containers/Logout/actions';

import { MFA_SETUP_REQUIRED_CLEAR } from './constants';
import i18n from './utils/i18n';
import * as styled from './styles/enforcedSetup';
import { MFASetup } from './MFASetup';

export const MFAEnforcedSetup = () => {
  const dispatch = useAppDispatch();

  const handleSetupComplete = useCallback(() => {
    dispatch({ type: MFA_SETUP_REQUIRED_CLEAR });
    window.location.href = '/';
  }, [dispatch]);

  const handleSignOut = useCallback(() => {
    dispatch(signOut({}, null));
  }, [dispatch]);

  return (
    <styled.EnforcedOverlay>
      <styled.EnforcedContainer>
        <styled.EnforcedHeader>
          <styled.EnforcedBadge>
            <FormattedMessage {...i18n.enforcedSetupBadge} />
          </styled.EnforcedBadge>
          <styled.EnforcedTitle>
            <FormattedMessage {...i18n.enforcedSetupTitle} />
          </styled.EnforcedTitle>
          <styled.EnforcedDescription>
            <FormattedMessage {...i18n.enforcedSetupDescription} />
          </styled.EnforcedDescription>
        </styled.EnforcedHeader>

        <MFASetup onSuccess={handleSetupComplete} embedded />
      </styled.EnforcedContainer>

      <styled.SignOutLink onClick={handleSignOut}>
        <FormattedMessage {...i18n.enforcedSetupSignOut} />
      </styled.SignOutLink>
    </styled.EnforcedOverlay>
  );
};
